import {
  createRequestReducer,
  createReducer
} from 'pobble-components/dist/redux-helpers'
import { combineReducers } from 'redux'

const EmailRequired = combineReducers({
  state: createReducer(
    {
      identityConnectMessageSent: false
    },
    {
      'FSU_EMAIL_REQUIRED:SEND_IDENTITY_SNATCH_REQUEST_SUCCESS': state => ({
        ...state,
        identityConnectMessageSent: true
      })
    }
  ),
  sendIdentityConnectRequest: createRequestReducer(
    'FSU_EMAIL_REQUIRED:SEND_IDENTITY_SNATCH'
  ),
  createEmailIdentityRequest: createRequestReducer(
    'FSU_EMAIL_REQUIRED:CREATE_EMAIL_IDENTITY',
    null,
    {
      'FSU_EMAIL_REQUIRED:CLOSE_OAUTH_MODAL': state => ({
        ...state,
        requestError: null
      })
    }
  )
})

export default EmailRequired
